
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 0a1 1 0 0 0-1 1v3c0 .255.106.501.281.688l14.406 15.311h14.625L43.718 4.687c.035-.037.066-.084.094-.125.043-.063.097-.115.125-.187.029-.074.02-.172.031-.25.007-.048.031-.076.031-.125V1a1 1 0 0 0-1-1H1zm15 22v17a.99.99 0 0 0 .5.844l10 6A.967.967 0 0 0 27 46c.17 0 .347-.038.5-.125A1 1 0 0 0 28 45V22H16zm16.906 9.969a1 1 0 0 0-.125.031 1 1 0 0 0-.5 1.719L39.562 41l-7.281 7.281a1.016 1.016 0 1 0 1.438 1.438l7.28-7.281 7.282 7.28a1.016 1.016 0 1 0 1.437-1.437l-7.28-7.28 7.28-7.282A1 1 0 0 0 48.875 32a1 1 0 0 0-.594.281L41 39.563l-7.282-7.282a1 1 0 0 0-.812-.312z"}})])
          )
        }
      }
    